import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const IntegracoesLinkedInPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/configuracoes?tab=synkly", { replace: true });
  }, [navigate]);

  return null;
};

export default IntegracoesLinkedInPage;
